import { toRefs, ref } from '@vue/composition-api'
import { fillSubfieldsWithDefaults } from '@/utils/subfields'
import { putAt } from '@shared/utils/array'

export default function useFormListWrapper ({ props, emit, createEmptyItem } = {}) {
  const { value: items } = toRefs(props)
  const editing = ref(null)

  function emitUpdate (value) {
    emit('input', value)
    emit('blur')
  }

  function updateItem (index, component, force = false) {
    if (!props.nestedMode || force) {
      emitUpdate(putAt(items.value, index, component))
    }
  }

  function deleteItem (index) {
    emitUpdate(items.value.filter((_, i) => i !== index))
  }

  function addItem () {
    emitUpdate([
      ...(items.value || []),
      newItem(),
    ], 'add')
    editing.value = items.value?.length || 0
  }

  function newItem () {
    const emptyItem = createEmptyItem()
    return fillSubfieldsWithDefaults(props.config.fields, emptyItem)
  }

  return {
    items,
    updateItem,
    addItem,
    deleteItem,
    emitUpdate,
    editing,
  }
}
